import React, { useState } from 'react';
import Cards from './card';
import TodayCard from './TodayCard';
import CanvasJSReact from '../../canvasjs.react';
var CanvasJS = CanvasJSReact.CanvasJS;
const CanvasJSChart = CanvasJSReact.CanvasJSChart;

const RightSide = () => {
  const [chartData, setChartData] = useState([
    { x: new Date("2018-03-01"), y: 85.3 },
    { x: new Date("2018-03-02"), y: 83.97 },
    { x: new Date("2018-03-29"), y: 88.15 }
  ]);

  const [options, setOptions] = useState({
    animationEnabled: true,
    theme: "light2",
    title: {
      text: "Task Report"
    },
    axisX: {
      valueFormatString: "DD MMM",
      crosshair: {
        enabled: true,
        snapToDataPoint: true
      }
    },
    axisY: {
      title: "Count",
      valueFormatString: "##0.00",
      crosshair: {
        enabled: true,
        snapToDataPoint: true,
        labelFormatter: function (e) {
          return "" + CanvasJS.formatNumber(e.value, "##0.00");
        }
      }
    },
    data: [{
      type: "area",
      xValueFormatString: "DD MMM",
      yValueFormatString: "##0.00",
      dataPoints: chartData
    }]
  });

  return (
    <div className='container-fluid'>
    <div className='row justify-content-center'>
    <div className='row'>
      <div className='col-md-12 mt-5'>
      <Cards/>
      </div>
    </div>
      
  </div>
  </div>
  );
};

export default RightSide;
